import * as d3 from 'd3'
export default {

  methods: {

    setDefaultValues(){     
    
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.config = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      this.areaBox = JSON.parse(JSON.stringify(this.Queries.SQL2))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title  = json.title
      this.phase  = json.phase
      this.area   = json.area
      this.gauge  = json.gauge
      this.summary   = json.summary
      this.tube   = json.tube
      this.milestone = json.milestone
      this.toggleButton = json.toggleButton

      // Current
      this.current = {
        area: {name: 'OVERALL', id: 'OV'}, 
        disc: {name: 'OVERALL', idx: null}, 
        reflash: null
      }

      // ------------------------------------------------ for Exporting PDF file
      this.getItems = this.getSelectItems ? JSON.parse(this.getSelectItems) : {}
      if (this.getItems.current) {
        this.current = this.getItems.current
      } // ---------------------------------------------------------------------
      

    },



  }
}